import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <circle cx="19.692" cy="19.692" r="19.692" fill={fill} />
                <g stroke={stroke} strokeLinecap="square" strokeWidth="1.64" transform="translate(10 10)">
                    <polyline points="14.806 4.355 14.806 0 4.355 0 4.355 6.967" />
                    <line x1="7.838" x2="11.322" y1="19.161" y2="19.161" />
                    <rect width="7.838" height="9.58" y="9.58" />
                    <rect width="7.838" height="12.193" x="11.322" y="6.967" />
                    <line x1="14.806" x2="15.677" y1="10.451" y2="10.451" />
                    <line x1="14.806" x2="15.677" y1="13.064" y2="13.064" />
                    <line x1="14.806" x2="15.677" y1="15.677" y2="15.677" />
                    <line x1="3.484" x2="4.355" y1="15.677" y2="15.677" />
                    <line x1="3.484" x2="4.355" y1="13.064" y2="13.064" />
                </g>
            </g>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd" stroke={stroke} strokeLinecap="square" transform="translate(1 1)">
                <polyline points="10.948 3.22 10.948 0 3.22 0 3.22 5.152" />
                <line x1="5.796" x2="8.372" y1="14.168" y2="14.168" />
                <rect width="5.796" height="7.084" y="7.084" />
                <rect width="5.796" height="9.016" x="8.372" y="5.152" />
                <line x1="10.948" x2="11.592" y1="7.728" y2="7.728" />
                <line x1="10.948" x2="11.592" y1="9.66" y2="9.66" />
                <line x1="10.948" x2="11.592" y1="11.592" y2="11.592" />
                <line x1="2.576" x2="3.22" y1="11.592" y2="11.592" />
                <line x1="2.576" x2="3.22" y1="9.66" y2="9.66" />
            </g>
        </svg>
    );
};

const MenuCompanyProfile = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuCompanyProfile.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuCompanyProfile;
